import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Button from 'UIKit/Button'
import useAuthenticationModal from 'hooks/useAuthenticationModal'
import { useTranslation } from 'react-i18next'
import { useUserInfo } from 'state/auth/hooks'
import styled from 'styled-components'
import { AuthModalPageEnums } from 'views/Authentication/types'

const ConnectionGroupButton: React.FC<BoxProps> = ({ ...props }) => {
  const [handlePresentAuthModal] = useAuthenticationModal()
  const { hasSession } = useUserInfo()
  const { t } = useTranslation()

  return (
    !hasSession && (
      <Container {...props}>
        <LogInButton id="login" onClick={() => handlePresentAuthModal({ page: AuthModalPageEnums.LOG_IN })}>
          {t('Log in')}
        </LogInButton>

        <SignUpButton id="signup" onClick={() => handlePresentAuthModal({ page: AuthModalPageEnums.SIGN_UP })}>
          {t('Sign up')}
        </SignUpButton>
      </Container>
    )
  )
}

const Container = styled(Box)`
  display: inline-flex;
  align-items: center;
  white-space: pre;
`

const LogInButton = styled(Button).attrs({ variant: 'text' })`
  font-size: 14px;
  font-weight: 700;
  padding: 0px !important;
  margin-right: 12px;
`

const SignUpButton = styled(Button).attrs({ variant: 'round' })`
  font-weight: 700;
  height: 36px !important;
  padding: 12px 16px !important;
  font-size: 14px !important;
  letter-spacing: 0.5px;
  box-sizing: border-box;
  outline: none;
  background: ${({ theme }) => theme.colors.primaryAlt};
  border-radius: ${({ theme }) => theme.radii.tiny} !important;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 12px 24px !important;
  }
`

export default ConnectionGroupButton
